import VerifyPhoneScreen from 'features/otp/challenges/VerifyPhoneNumber/VerifyPhoneNumber';
import React from 'react';

export default function Page() {
  return <VerifyPhoneScreen />;
}
